import React, { useRef, useState } from 'react';

import FilterData from '../../../../components/FilterAnalyze/FilterData/FilterData';
import QntUserReport from './Components/Reports/QntClientsReport';
import QntClientsGraphic from './Components/Graphics/QntClientsGraphic';

/**
 * Component for show the bot attendance time screen on reports
 *
 * @returns
 */
const QntClients = ({ parentFilter, onClickFilter }) => {
  const [refGraphic, setRefGraphic] = useState(useRef(null));

  const getChildRefGraphic = (ref) => {
    setRefGraphic(ref);
  };

  return (
    <div>
      <FilterData
        onClickFilter={onClickFilter}
        graphicReference={refGraphic}
        graphicName="qnt-clients"
        showDownload
        showMoreFilters
      />
      <QntUserReport componentData={{ parentFilter }} />
      <QntClientsGraphic
        componentData={{ parentFilter }}
        getRefGraphic={getChildRefGraphic}
      />
    </div>
  );
};
export default QntClients;
